import React from 'react';
import './Catering.css';
import { UtensilsCrossed, Drumstick, Beef, Utensils } from 'lucide-react';

const menu = [
  {
    title: 'Starters',
    icon: <Utensils size={18} strokeWidth={1.6} />,
    items: ['Cocktail Puff Puff', 'Jerk BBQ Wings', 'Veg Spring Rolls', 'Tempura Prawns'],
  },
  {
    title: 'Main Dishes',
    icon: <Drumstick size={18} strokeWidth={1.6} />,
    items: ['Jollof Rice', 'Fried Rice', 'Asaro & Sauce', 'Poundo & Efo Riro', 'Leaf Salad', 'Plantain'],
  },
  {
    title: 'Proteins',
    icon: <Beef size={18} strokeWidth={1.6} />,
    items: ['Beef', 'Chicken', 'Fish'],
  },
  {
    title: 'Post-Main Savouries',
    icon: <UtensilsCrossed size={18} strokeWidth={1.6} />,
    items: ['Yam Chips', 'Peppered Turkey Wings', 'Suya Bites'],
  }
];

export default function Catering({ onRsvp }) {
  return (
    <div className="page-wrapper catering-page">
      <div className="section-header">
        <span className="section-eyebrow">A Feast to Remember</span>
        <h2 className="section-title">The <em>Menu</em></h2>
        <div className="gold-line" />
      </div>

      <div className="catering__inner">
        <div className="catering__notice fade-up">
          <span className="catering__notice-icon">✦</span>
          <p>
            <strong>Allergy Notice — </strong>If you or anyone in your party has
            food allergies or dietary requirements, please let us know.
          </p>
        </div>

        <div className="catering__grid">
          {menu.map((col, index) => (
            <div
              key={col.title}
              className="catering__col fade-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="catering__col-header">
                <div className="catering__col-icon">{col.icon}</div>
                <h3 className="catering__col-title">{col.title}</h3>
              </div>

              <ul className="catering__list">
                {col.items.map((item) => (
                  <li key={item}>
                    <span className="catering__list-dot" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="catering__closing fade-up">
          All dishes prepared fresh on the day with love ✦
        </p>
      </div>
    </div>
  );
}